(() => {
  // Prefer the requested size only when buyable. Retain it if the entire color is sold out.
  const chooseVariant = (variants, size) => {
    const same = variants.find(variant => variant.option1 === size);
    return (same?.available && same) || variants.find(variant => variant.available) || same || variants[0];
  };
  const parseVariants = value => {
    try { const variants = JSON.parse(value || '[]'); return Array.isArray(variants) ? variants : []; }
    catch { return []; }
  };
  const initialize = () => document.querySelectorAll('product-info.sh-family-main').forEach(root => {
    const colors = root.querySelector('[data-sh-family-colors]');
    if (!colors || colors.dataset.ready) return;
    colors.dataset.ready = 'true';
    const links = [...colors.querySelectorAll('[data-sh-color-url]')];
    const variantsByLink = new Map(links.map(link => [link, parseVariants(link.dataset.shColorVariants)]));
    const pending = new Map();
    const selectedSize = () => root.querySelector('variant-selects select')?.value || colors.dataset.shSelectedSize || '';
    const setTarget = link => {
      const target = chooseVariant(variantsByLink.get(link) || [], selectedSize());
      const url = new URL(link.dataset.shColorUrl, location.origin);
      if (target) url.searchParams.set('variant', target.id);
      else url.searchParams.delete('variant');
      link.href = url.href;
    };
    const update = () => links.forEach(setTarget);
    const refresh = link => {
      if (link.getAttribute('aria-current') === 'page') {
        variantsByLink.set(link, parseVariants(colors.dataset.shCurrentVariants));
        setTarget(link);
        return Promise.resolve();
      }
      if (pending.has(link)) return pending.get(link);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const url = new URL(link.dataset.shColorUrl, location.origin);
      url.searchParams.delete('variant');
      // Render the destination in its own locale/theme/preview context. Draft product JSON
      // endpoints cannot supply this data; the HTML contains Shopify's live variants.
      const request = fetch(url.href, {cache:'no-store', signal:controller.signal})
        .then(response => { if (!response.ok) throw new Error('Color unavailable'); return response.text(); })
        .then(html => {
          const page = new DOMParser().parseFromString(html, 'text/html');
          const data = page.querySelector('[data-sh-family-colors]');
          const variants = parseVariants(data?.dataset.shCurrentVariants);
          if (variants.length) variantsByLink.set(link, variants);
          setTarget(link);
        })
        .catch(() => setTarget(link)) // Native links and the last verified data remain usable offline.
        .finally(() => { clearTimeout(timeout); pending.delete(link); });
      pending.set(link, request);
      return request;
    };
    root.addEventListener('rl:size-selected', update);
    root.addEventListener('change', event => { if (event.target.closest('variant-selects')) update(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => { if (event.data.sectionId === root.dataset.section) update(); });
    }
    links.forEach(link => {
      link.addEventListener('focus', () => refresh(link));
      link.addEventListener('pointerenter', () => refresh(link));
      link.addEventListener('click', async event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        await refresh(link);
        setTarget(link); // Read the latest size after any in-flight selection changes.
        link.removeAttribute('aria-busy');
        location.assign(link.href);
      });
    });
    update();
    links.forEach(refresh);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
